/** Tokens do messenger da Central de suporte (Início / Mensagens / Ajuda / Novidades). */
import { ASSISTANT_THEME } from '../assistantTheme';

export const MESSENGER = {
  teal: ASSISTANT_THEME.teal,
  tealDark: ASSISTANT_THEME.tealDark,
  tealBright: ASSISTANT_THEME.tealBright,
  tealSoft: ASSISTANT_THEME.tealSoft,
  navy: ASSISTANT_THEME.navy,
  slate: ASSISTANT_THEME.slateMid,
  slateFaint: ASSISTANT_THEME.slateFaint,
  border: ASSISTANT_THEME.borderSoft,
  surface: '#FFFFFF',
  canvas: '#F8FAFC',
  inputBg: '#F1F5F9',
  heroGradient:
    'linear-gradient(180deg, #0D9488 0%, #14B8A6 34%, rgba(20, 184, 166, 0.55) 58%, rgba(248, 250, 252, 1) 100%)',
  cardShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 14px rgba(15, 23, 42, 0.07)',
} as const;

export const messengerCardSx = {
  bgcolor: MESSENGER.surface,
  borderRadius: '14px',
  boxShadow: MESSENGER.cardShadow,
  border: `1px solid rgba(226, 232, 240, 0.7)`,
  overflow: 'hidden',
} as const;

export const messengerCardButtonSx = {
  ...messengerCardSx,
  width: '100%',
  flexShrink: 0,
  textAlign: 'left' as const,
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  px: 2,
  py: 1.6,
  cursor: 'pointer',
  font: 'inherit',
  color: 'inherit',
  transition: 'box-shadow 0.15s ease, transform 0.15s ease',
  '&:hover': { boxShadow: '0 6px 20px rgba(15, 23, 42, 0.1)' },
  '&:focus-visible': { outline: `2px solid ${MESSENGER.teal}`, outlineOffset: 2 },
};

/** Card clicável com capa em cima (blog / novidades) — não encolhe dentro de coluna flex com scroll. */
export const messengerCardVerticalButtonSx = {
  ...messengerCardSx,
  width: '100%',
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'stretch',
  textAlign: 'left' as const,
  p: 0,
  cursor: 'pointer',
  font: 'inherit',
  color: 'inherit',
  transition: 'box-shadow 0.15s ease',
  '&:hover': { boxShadow: '0 6px 20px rgba(15, 23, 42, 0.1)' },
  '&:focus-visible': { outline: `2px solid ${MESSENGER.teal}`, outlineOffset: 2 },
};

export const messengerListRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  width: '100%',
  px: 2,
  py: 1.5,
  textAlign: 'left' as const,
  border: 0,
  bgcolor: 'transparent',
  cursor: 'pointer',
  font: 'inherit',
  color: 'inherit',
  borderBottom: `1px solid ${MESSENGER.border}`,
  transition: 'background-color 0.12s ease',
  '&:hover': { bgcolor: 'rgba(15, 23, 42, 0.03)' },
  '&:focus-visible': { outline: `2px solid ${MESSENGER.teal}`, outlineOffset: -2 },
};

export const messengerSearchShellSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  bgcolor: MESSENGER.inputBg,
  borderRadius: '10px',
  px: 1.5,
  py: 0.25,
  border: '1px solid transparent',
  transition: 'border-color 0.15s ease, background-color 0.15s ease',
  '&:focus-within': { borderColor: MESSENGER.teal, bgcolor: MESSENGER.surface },
};

export const messengerTitleSx = {
  fontWeight: 700,
  fontSize: '0.875rem',
  color: MESSENGER.navy,
  lineHeight: 1.35,
} as const;

export const messengerSubtitleSx = {
  fontSize: '0.8rem',
  color: MESSENGER.slate,
  lineHeight: 1.4,
} as const;

export function formatMessengerRelativeTime(value?: string | null): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const diffMin = Math.max(0, Math.round((Date.now() - d.getTime()) / 60000));
  if (diffMin < 1) return 'agora';
  if (diffMin < 60) return `${diffMin} min`;
  const diffH = Math.round(diffMin / 60);
  if (diffH < 24) return `${diffH}h`;
  const diffD = Math.round(diffH / 24);
  if (diffD < 7) return `${diffD}d`;
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
}

export function formatNewsDate(value: string): string {
  if (!value) return '';
  const d = new Date(`${value}T12:00:00`);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' }).replace('.', '');
}
